import { casesLib } from '@/Constants/casesLib';
import { tCaseModel } from '@/Interfaces/caseComponentsLib';
import { caseComponentsLib } from '@/Constants/caseComponentsLib/caseComponentsLib';
import { drawerSeparators } from '@/Constants/caseComponentsLib/drawerSeparators';

export function getCaseDataByModel(model: tCaseModel | undefined) {
    return casesLib.find(item => item.key === model);
}

export function getCaseItemPrototypeById(prototypeId: string) {
    return caseComponentsLib.find(item => item.id === prototypeId);
}

export function getDrawerSeparatorPrototypeById(prototypeId: string) {
    return drawerSeparators.find(item => item.id === prototypeId);
}

export function getCaseDataByXmlId(xmlId: string) {
    return casesLib.find(item => item.xmlId === xmlId);
}
